import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { noteActions } from 'store';
import { FormBuilder } from '../../../pages/forms/formBuilder';

export const AddNoteForm = ({ info, resourceId, formModel, noteModal, requestParams }) => {
    const ACTION_TYPE = !!info ? 'EDIT_GLOBAL_NOTE' : 'CREATE_GLOBAL_NOTE';
    const dispatch = useDispatch();
    const handleSaveNote = (data) => {
        const noteData = {
            ...data,
            resource: resourceId,
            onModel: noteModal,
        };

        delete noteData?.id;
        if (!!info) {
            dispatch(noteActions.editGlobalNote(resourceId, info?.id, noteData, '', requestParams));
        } else {
            dispatch(noteActions.createGlobalNote(noteData, requestParams));
        }
    };

    useEffect(() => {
        if (info?.id) dispatch(noteActions.viewNote({ ids: [info?.id] }));
    }, []);

    return (
        <div>
            <FormBuilder
                info={info}
                resourceId={resourceId}
                formModel={formModel}
                // afterSuccess={afterSuccess}
                ACTION_TYPE={ACTION_TYPE}
                handleSaveNote={handleSaveNote}
            />
        </div>
    );
};
